import { useAxiosModule } from '@/modules/_shared/axios'
import { FailedLoginAttempt, FailedLoginAttemptsResponse } from './types'

const {
    getFromApi,
    deleteInApi,
    apiUrl,
    mockAdapter
} = useAxiosModule()

/* Get Failed login attempts list */

export type GetFailedLoginAttemptsResponse = FailedLoginAttemptsResponse
export async function getFailedLoginAttempts (search = '', sortBy = 'id desc', limit = 0, offset = 0) {
    const queryParams = new URLSearchParams()
    queryParams.set('search', search)
    queryParams.set('sort', sortBy)
    queryParams.set('limit', String(limit))
    queryParams.set('offset', String(offset))
    const url = 'system_access/members-failed-login-attempts?' + queryParams.toString()
    return getFromApi<GetFailedLoginAttemptsResponse>(url)
}

/* Get Failed login attempt */

export type GetFailedLoginAttemptResponse = FailedLoginAttempt
export async function getFailedLoginAttempt (id: string) {
    return getFromApi<GetFailedLoginAttemptResponse>(`system_access/members-login-attempt/${id}`)
}

/* Delete Failed login attempt */

export async function deleteFailedLoginAttempt (id: string) {
    return deleteInApi<null>(`system_access/members-login-attempt/${id}`)
}
